const BLOG_UPLOAD_STRIP_KEYS = [
  "id",
  "createAt",
  "createdAt",
  "updatedAt",
  "url",
  "image",
];

export const sanitizeBlogUploadItem = (item) => {
  if (!item || typeof item !== "object") {
    return null;
  }

  const sanitized = { ...item };

  BLOG_UPLOAD_STRIP_KEYS.forEach((key) => {
    delete sanitized[key];
  });

  if (!sanitized.firstImage && item.image) {
    sanitized.firstImage = item.image;
  }

  if (!sanitized.btnTitle) {
    sanitized.btnTitle = "Read More";
  }

  if (!sanitized.date) {
    sanitized.date = "Today";
  }

  if (!sanitized.secondImage) {
    sanitized.secondImage = "./assets/blog/technology.png";
  }

  if (!Array.isArray(sanitized.answereList)) {
    sanitized.answereList = [{ id: "1", pointOne: "" }];
  }

  return sanitized;
};

export const sanitizeBlogUploadItems = (items) =>
  items.map(sanitizeBlogUploadItem).filter(Boolean);
